<template>
  <div class="detail-container">
    <router-view></router-view>
  </div>
</template>

<script>
import { getReportDetail } from '@/utils/axios';


export default {
  name: 'llkjBackDetail',

  data () {
    return {
    };
  },

  mounted () {

  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
.detail-container {
  position: relative;
  width: 1920px;
  height: 1080px;
  min-width: 1920px;
  color: #282A2C;
  overflow: hidden;
}
</style>